const Phaser = window.Phaser;

export default Phaser;